// packages block
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
// common block
import "./style.css";
import { TableHeader } from "./components";
import { AddBankDialog } from "../../components/dialogs";
import { ManagementTable } from "../../components/managementTable";
import { StudentConfirmationDeleteDialog } from "../../components/dialogs/studentConfirmationDeleteDialog";
// constants, theme, utils and api block
import { setAlert } from "../../redux/reducers/alert";
import { deleteBank, getAllBanks, getLeanBankList, searchBanks } from "../../api/banks";
import { AddBankSelectDialog } from "../../components/dialogs/addBankSelectDialog";

export const BankManagement = () => {
  const { t } = useTranslation();
  const [banks, setBanks] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [banksData, setBanksData] = useState([]);
  const [defaultAccountsData, setDefaultAccountsData] = useState([]);
  const [isPreAddDialogVisible, setIsPreAddDialogVisible] = useState(false);
  const [isAddBankDialogVisible, setIsAddBankDialogVisible] =
    useState(false);
  const [isAddBankSelectDialogVisible, setIsAddBankSelectDialogVisible] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [
    isConfirmationDeleteDialogVisible,
    setIsConfirmationDeleteDialogVisible,
  ] = useState(false);
  const [rowSelectedId, setRowSelectedId] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [SearchValue, setSearchValue] = useState("");
  const [bankValue, setBankValue] = useState('');
  const [isDefaultAccount, setIsDefaultAccount] = useState(false);
  const [startEntry, setStartEntry] = useState(1)
  const [endEntry, setEndEntry] = useState(10)
  const [page, setPage] = useState(0);
  const { token, role, id, bankId, schoolId } = useSelector((state) => state.user);
  const closePreAddDialog = () => setIsPreAddDialogVisible(false);
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];

  const openAddBankSelectDialog = async (data) => {
    const response = await getLeanBankList(data)
    setBanks(response.banks)
    closePreAddDialog();
    setIsAddBankSelectDialogVisible(true)
    setIsAddBankDialogVisible(false);
  };

  const closeAddBankSelectDialog = () => {
    setIsAddBankSelectDialogVisible(false)
    setIsAddBankDialogVisible(true);
  };

  const closeAddBankDialog = () => {
    setIsAddBankDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const dispatch = useDispatch();
  const history = useHistory();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const handleSelection = (ids) => setSelectedIds(ids);

  const successCallback = async () => {
    closeAddBankDialog();
    fetchBanks();

    setIsEditedItem(null);
  };

  const deleteCallback = async () => {
    fetchBanks();
    setSelectedIds(false);
  };
  let limit = 10;
  const fetchBanks = async () => {
    try {
      const payload = {
        schoolId,
        role
      };
      const response = await getAllBanks(payload, page, token, limit);
      setStartEntry(page === 0 ? 1 : (page) * limit + 1)
      setEndEntry((page + 1) * limit > response?.accounts?.count
        ? response?.accounts?.count
        : (page + 1) * limit)
      setDefaultAccountsData(response?.defaultAccount.rows)

      if (response?.status) {
        setBanksData(response?.accounts?.rows);
        setBankValue(response?.accounts?.rows[0]?.id)
        setTotalCount(response?.accounts?.count);
      } else {
        showErrorAlert(response?.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      showErrorAlert(e || e?.message || t("text_something_went_wrong_try_again_later"));
    }
  };

  useEffect(() => {
    if (SearchValue === "") {
      fetchBanks();
    } else {
      (async () => {
        setLoading(true);
        try {
          setBanksData([]);
          const payload = {
            role,
            id,
            bankId,
          };
          const response = await searchBanks(payload, SearchValue, token);
          if (response.status) {
            setBanksData(response?.banks);
            if (response.banks.length === 0) {
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (e) {
          showErrorAlert(e.message || t("text_error_in_searching_banks"));
          setLoading(false);
        }
      })();
    }
  }, [SearchValue, page]);
  // const handleSearching = (e) => {
  //   setPage(0);
  //   setSearchValue(e);
  // };
  const deleteItem = async () => {
    try {
      await deleteBank(rowSelectedId, token);
      local.push({
        message: t("text_bank_deleted_successfully"),
        date: new Date().getTime(),
        newNotification: true,
      });
      localStorage.setItem("notify", JSON.stringify(local));
      setIsConfirmationDeleteDialogVisible(false);
      deleteCallback();
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_bank_please_try_again")
      );
    }
  };
  const handleCancel = () => {
    setIsConfirmationDeleteDialogVisible(false);
  };
  const handlePage = (pageNumber) => setPage(pageNumber);

  const editBank = (item) => {
    setIsEditedItem(item);
    setIsAddBankDialogVisible(true);
  };

  const editSuccessCallback = async (item) => {
    const updatedBanks = banks.map((bankItem) => {
      if (bankItem.id === item.id) {
        return item;
      } else return bankItem;
    });
    closeAddBankDialog();
    setBanksData(updatedBanks);
  };

  const viewItem = async (id) => history.push({
    pathname: `/accounts/accounts-detail/${id}`,
    state: {
      banks: banksData,
    },
  });

  const BANK_MANAGMENT_COLUMNS = [
    { id: "bankName", numeric: false, disablePadding: true, label: t("text_bank_name") },
    { id: "bankSwiftCode", numeric: false, disablePadding: true, label: t("text_bank_swift_code"), },
    { id: "bankAddress", numeric: false, disablePadding: true, label: t("text_bank_address") },
    { id: "accountNumber", numeric: false, disablePadding: true, label: t("text_account_number") },
    { id: "accountTitle", numeric: false, disablePadding: true, label: t("text_account_title") },
    { id: "accountIban", numeric: false, disablePadding: true, label: t("text_account_iban"), },
    { id: "defaultAccount", numeric: false, disablePadding: true, label: "Default Account", },
    { id: "actions", numeric: false, disablePadding: true, label: "" },
  ];
  const currentBankName = banks?.filter(v => v.id === bankValue);

  return (
    <div className="bank-management-page">
      <Typography variant="h4" style={{ fontFamily: "Monsteric, sans-serif", marginBottom: 20 }}>
        {t("text_bank_management")}</Typography>

      <div className={"bank-management-container"}>
        <TableHeader
          // searchValue={handleSearching}
          tableFor="accounts"
          handleAdd={openAddBankSelectDialog}
        />

        {loading ? (
          <div className={"bank-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_banks_data")}
          </div>
        ) : (
          <ManagementTable
            defaultAccountsData={defaultAccountsData}
            pageNumber={page}
            totalCount={totalCount}
            handlePage={handlePage}
            handleSelection={handleSelection}
            data={banksData}
            columns={BANK_MANAGMENT_COLUMNS}
            deleteItem={deleteItem}
            tableFor="accounts"
            editItem={editBank}
            isConfirmationDeleteDialogVisible={
              isConfirmationDeleteDialogVisible
            }
            setIsConfirmationDeleteDialogVisible={
              setIsConfirmationDeleteDialogVisible
            }
            setRowSelectedId={setRowSelectedId}
            viewItem={viewItem}
            startEntry={startEntry}
            endEntry={endEntry}
          />
        )}
      </div>

      {/*changing in bank field and dialog open.*/}

      {isAddBankSelectDialogVisible && (
        <AddBankSelectDialog
          banksData={banks}
          setBankValue={setBankValue}
          title={"Select Bank"}
          setIsAddBankDialogVisible={setIsAddBankDialogVisible}
          handleClose={closeAddBankSelectDialog}
          open={isAddBankSelectDialogVisible}
        />
      )}

      {isAddBankDialogVisible && (
        <AddBankDialog
          bankValue={bankValue}
          bankName={currentBankName[0]?.name}
          title={isEditedItem ? t("text_edit_bank") : t("text_add_bank")}
          handleClose={closeAddBankDialog}
          open={isAddBankDialogVisible}
          successCallback={successCallback}
          isEditedItem={isEditedItem}
          editSuccessCallback={editSuccessCallback}
        />
      )}
      {isConfirmationDeleteDialogVisible && (
        <StudentConfirmationDeleteDialog
          open={isConfirmationDeleteDialogVisible}
          close={handleCancel}
          title={t("text_bank")}
          handleDelete={deleteItem}
        />
      )}
    </div>
  );
};
